import axios from 'axios'

const state = { branches: [] }

const getters = {}

const actions = {
	findAll(context) {
		axios.get('branch').then(res => {
			context.commit('SET_BRANCHES', res.data)
		})
	}
}

const mutations = {
	SET_BRANCHES(state, value) {
		state.branches = value
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
